export default async (context, info) => {
    await context.$store.dispatch('edit/setEditableItem', {
        data: info
    })
    if(info.type === 'video') {

        await context.$store.dispatch('edit/setControl', {
            control: info.control
        })

        if(info.control === 'entry') {
            context.$router.push('/add-entry')
        } else if (info.control === 'main') {
            context.$router.push('/add-video')
        } else if (info.control === 'ending') {
            context.$router.push('/add-ending-select')
        }
    } else if(info.type === 'text') {
        context.$router.push('/add-text')
    } else if(info.type === 'music') {
        context.$router.push('/add-music')
    }
}